export const environment = {
  production: true,
  aiApiRootUrl: '/api',
};
